import { useEffect, useState } from "react";
import gamefacts from "./gamefacts.js";

export function useGameFact({_id, type, detail = {}}){

    // On se sert de l'id pour retrouver le gameFact dans la liste
    const {img , imgSucceed, imgFailed, steps, recapComponent, defaultState = {}} = gamefacts.find(gf => gf.id === type)
    const [state, setState] = useState({...detail})

    useEffect(() => {
        setState({...detail, ...defaultState })
    }, [type])

    return [img, imgSucceed, imgFailed, steps, state, setState, recapComponent]
}

